import { render, staticRenderFns } from "./depositPopup.vue?vue&type=template&id=f809f5ae&scoped=true&"
import script from "./depositPopup.vue?vue&type=script&lang=js&"
export * from "./depositPopup.vue?vue&type=script&lang=js&"
import style0 from "./depositPopup.vue?vue&type=style&index=0&id=f809f5ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f809f5ae",
  null
  
)

export default component.exports